// extracted by mini-css-extract-plugin
export default {"modal":"UB","topline":"VB","img":"WB","textcontents":"XB","heading":"YB","copy":"ZB","link":"aC","close":"bC","modalinner":"cC","container":"eC"};
    if(module.hot) {
      // 1743628923631
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  